import { defineRequest, defineRequestWithParam } from "../axios"
import type {
    AddMemberNotesPayload,
    MemberDetail,
    MemberEventListResponse,
    MemberJourneyEventListResponse,
    MemberListResponse,
    MemberNoteListResponse,
    MemberTagListResponse,
    PatchMemberBlockingPayload,
} from "./types"

// 取得會員列表
export const getMemberList = defineRequest<MemberListResponse>({
    url: "/members/",
    method: "get",
})

// 取得會員詳細資料
export const getMemberDetail = defineRequestWithParam<MemberDetail>({
    url: (memberId: string) => `/members/${memberId}/`,
    method: "get",
})

// 更新會員詳細資料
export const updateMemberDetail = defineRequestWithParam<void>({
    url: (memberId: string) => `/members/${memberId}/`,
    method: "put",
})

// 更新會員部分詳細資料
export const patchMemberDetail = defineRequestWithParam<void>({
    url: (memberId: string) => `/members/${memberId}/`,
    method: "patch",
})

// 更新會員封鎖狀態
export const patchMemberBlocking = defineRequestWithParam<void, PatchMemberBlockingPayload>({
    url: (memberUuid: string) => `/members/${memberUuid}/block-info/`,
    method: "patch",
})

// 更新會員封鎖狀態
export const updateMemberBlocking = defineRequestWithParam<void>({
    url: (memberUuid: string) => `/members/${memberUuid}/block-info/`,
    method: "put",
})

// 取得會員活動列表
export const getMemberEvents = defineRequestWithParam<MemberEventListResponse>({
    url: (memberId: string) => `/members/${memberId}/events/`,
    method: "get",
})

// 取得會員旅程活動列表
export const getMemberJourneyEvents = defineRequestWithParam<MemberJourneyEventListResponse>({
    url: (memberId: string) => `/members/${memberId}/journey-events/`,
    method: "get",
})

// 取得會員標籤列表
export const getMemberTags = defineRequestWithParam<MemberTagListResponse>({
    url: (memberId: string) => `/members/${memberId}/tags/`,
    method: "get",
})

// 取得會員備註列表
export const getMemberNotes = defineRequestWithParam<MemberNoteListResponse>({
    url: (memberId: string) => `/members/${memberId}/notes/`,
    method: "get",
})

// 建立會員備註列表
export const addMemberNotes = defineRequestWithParam<void, AddMemberNotesPayload>({
    url: (memberId: string) => `/members/${memberId}/notes/`,
    method: "post",
})
